module.exports = __webpack_public_path__ + "media/images/85/insomnia_moon_dark_skies-8a117df2e0944a6c0dc390fe81a20de3.jpg";